

const Backdrop = ({onClick, className='z-modal-backdrop'}) => <div className={`backdrop ${className}`} onClick={onClick}/>;

export default Backdrop;